import React, { lazy, Suspense } from 'react';
import { Hero } from './components/Hero';
import { UrgencyBanner } from './components/UrgencyBanner';
import { MetaPixel } from './components/MetaPixel';
const PainAndProduct = lazy(() => import('./components/PainProduct').then(module => ({
  default: module.PainAndProduct
})));
const TomosAndBonos = lazy(() => import('./components/TomosBonos').then(module => ({
  default: module.TomosAndBonos
})));
const Precios = lazy(() => import('./components/Precios').then(module => ({
  default: module.Precios
})));
const TestimonialsAndFaq = lazy(() => import('./components/TestimonialsFaq').then(module => ({
  default: module.TestimonialsAndFaq
})));
const CtaAndFooter = lazy(() => import('./components/Footer').then(module => ({
  default: module.CtaAndFooter
})));
const SocialProofToast = lazy(() => import('./components/SocialProofToast').then(module => ({
  default: module.SocialProofToast
})));
const StickyCTA = lazy(() => import('./components/Shared').then(module => ({
  default: module.StickyCTA
})));
export function App() {
  return <div className="landing-page min-h-screen bg-brand-base font-sans text-brand-text selection:bg-brand-orange selection:text-white pb-20 md:pb-0" data-id="element-0" data-mp="3ii4ro0w5cqo1">
      <MetaPixel data-id="element-1" data-mp="3rdaselgk8ijp" />
      <UrgencyBanner data-id="element-2" data-mp="3rcswjpxt86cb" />
      <Hero data-id="element-3" data-mp="3recc1ebn6dd1" />
      <Suspense fallback={null} data-id="element-4" data-mp="5yimri0b7dt">
        <PainAndProduct data-id="element-5" data-mp="682rygdekbl" />
        <TomosAndBonos data-id="element-6" data-mp="5ghbgghm2z1" />
        <Precios data-id="element-7" data-mp="7suzhf7pr6a" />
        <TestimonialsAndFaq data-id="element-8" data-mp="2zld0l5ad579f" />
        <CtaAndFooter data-id="element-9" data-mp="2zm4zaoz9bl3x" />
        <SocialProofToast data-id="element-10" data-mp="2zmo7vf30ox5a" />
        <StickyCTA data-id="element-11" data-mp="2zng1wlgyumtg" />
      </Suspense>
    </div>;
}